module.exports = __webpack_public_path__ + "static/media/icon-flip-door-front-to-back.c9a1c06f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-flip-door-front-to-back.svg
// module id = 954
// module chunks = 0